import * as React from 'react';
import {View} from 'react-native';
import ScanditViewProps from './ScanditViewProps';

export default function ScanditView(props: ScanditViewProps) {
  return <View />;
}
